import { useAtomValue } from 'jotai';

// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';

// Components
import { DatepickerRange } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/DatepickerRange';
import { DatepickerSingle } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/DatepickerSingle';

export type DatepickerCalendarProps = {
    displayDataRetentionBanner?: boolean;
};

export function DatepickerCalendar(props: DatepickerCalendarProps) {
    const datepicker = useAtomValue(datepickerAtom);

    if (datepicker.mode === 'range') {
        return <DatepickerRange {...props} />;
    }

    return <DatepickerSingle {...props} />;
}
